import { render, staticRenderFns } from "./sumProblem_division.vue?vue&type=template&id=2ef17981&scoped=true"
import script from "./sumProblem_division.vue?vue&type=script&lang=js"
export * from "./sumProblem_division.vue?vue&type=script&lang=js"
import style0 from "./sumProblem_division.vue?vue&type=style&index=0&id=2ef17981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef17981",
  null
  
)

export default component.exports